import useUnlockedPromotionByLastAction from 'bento-ordering/promotions/hooks/useUnlockedPromotionByLastAction';
import useClosestPromotionToUnlock from 'bento-ordering/promotions/hooks/useClosestPromotionToUnlock';
import { promotionTypes } from 'constants/promotions';
import { formatSentenceWithAVsAn } from 'bento-ordering/utils/formatSentenceWithAVsAn';

export function getQualifyingItemMessage(
  closestPromotionToUnlock,
  qualifyingItemName,
  rewardItemName
) {
  let promoMessage = '';
  if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length > 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length === 0
  ) {
    promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock ${closestPromotionToUnlock.promotion.name}`;
  } else if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length > 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length === 1
  ) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock ${closestPromotionToUnlock.promotion.free_item_quantity}x FREE ${rewardItemName}`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock a $${closestPromotionToUnlock.promotion.special_item_price} ${rewardItemName}`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FIXED_AMOUNT
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock $${closestPromotionToUnlock.promotion.fixed_amount_off} off a ${rewardItemName}`;
    } else {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock ${closestPromotionToUnlock.promotion.percentage_off}% off a ${rewardItemName}`;
    }
  } else if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length > 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length > 1
  ) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock FREE items`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock discounted items`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FIXED_AMOUNT
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock $${closestPromotionToUnlock.promotion.fixed_amount_off} off select items`;
    } else {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x qualifying item(s) to unlock ${closestPromotionToUnlock.promotion.percentage_off}% off select items`;
    }
  } else if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length === 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length === 0
  ) {
    promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock ${closestPromotionToUnlock.promotion.name}`;
  } else if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length === 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length === 1
  ) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock ${closestPromotionToUnlock.promotion.free_item_quantity}x FREE ${rewardItemName}`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock a $${closestPromotionToUnlock.promotion.special_item_price} ${rewardItemName}`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FIXED_AMOUNT
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock $${closestPromotionToUnlock.promotion.fixed_amount_off} off a ${rewardItemName}`;
    } else {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock ${closestPromotionToUnlock.promotion.percentage_off}% off a ${rewardItemName}`;
    }
  } else if (
    closestPromotionToUnlock.promotion.qualifying_item_details.length === 1 &&
    closestPromotionToUnlock.promotion.product_promotion_details.length > 1
  ) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock FREE items`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock discounted items`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FIXED_AMOUNT
    ) {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock $${closestPromotionToUnlock.promotion.fixed_amount_off} off select items`;
    } else {
      promoMessage = `Add ${closestPromotionToUnlock.quantity_until_bogo_unlocked}x ${qualifyingItemName} to unlock ${closestPromotionToUnlock.promotion.percentage_off}% off select items`;
    }
  }
  return promoMessage;
}

export function getRewardItemMessage(closestPromotionToUnlock, rewardItemName) {
  let promoMessage = '';
  if (closestPromotionToUnlock.promotion.product_promotion_details.length > 1) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock FREE items`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock discounted items`;
    } else {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock ${closestPromotionToUnlock.promotion.name}`;
    }
  } else if (
    closestPromotionToUnlock.promotion.product_promotion_details.length === 1
  ) {
    if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.FREE_ITEM
    ) {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock ${closestPromotionToUnlock.promotion.free_item_quantity}x FREE ${rewardItemName}`;
    } else if (
      closestPromotionToUnlock.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock a $${closestPromotionToUnlock.promotion.special_item_price} ${rewardItemName}`;
    } else {
      promoMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock ${closestPromotionToUnlock.promotion.name}`;
    }
  }
  return promoMessage;
}

function getUnlockedRewardItemMessage(unlockedPromotion, rewardItemName) {
  let promoMessage = '';
  if (unlockedPromotion.promotion.product_promotion_details.length === 1) {
    if (
      unlockedPromotion.promotion.promotion_type === promotionTypes.FREE_ITEM
    ) {
      promoMessage = `FREE ${rewardItemName} unlocked!`;
    } else if (
      unlockedPromotion.promotion.promotion_type ===
      promotionTypes.SPECIAL_ITEM_PRICING
    ) {
      promoMessage = `$${unlockedPromotion.promotion.special_item_price} ${rewardItemName} unlocked!`;
    } else {
      promoMessage = `${unlockedPromotion.promotion.name} unlocked!`;
    }
  } else if (unlockedPromotion.promotion.product_promotion_details.length > 1) {
    if (
      unlockedPromotion.promotion.promotion_type === promotionTypes.FREE_ITEM
    ) {
      promoMessage = 'FREE items unlocked!';
    } else if (
      unlockedPromotion.promotion.promotion_type ===
        promotionTypes.SPECIAL_ITEM_PRICING ||
      unlockedPromotion.promotion.promotion_type ===
        promotionTypes.FIXED_AMOUNT ||
      unlockedPromotion.promotion.promotion_type ===
        promotionTypes.PERCENT_AMOUNT
    ) {
      promoMessage = 'Discounted items unlocked!';
    }
  }
  return `${promoMessage} Apply at checkout.`;
}

function handlePromotionProgressUpdateMessage(
  unlockedPromotion,
  closestPromotionToUnlock,
  qualifyingItemName,
  rewardItemName,
  unlockedPromotionRewardItemName
) {
  let promotionMessage = '';

  if (unlockedPromotion) {
    if (unlockedPromotion.promotion.product_promotion_details.length >= 1) {
      promotionMessage = getUnlockedRewardItemMessage(
        unlockedPromotion,
        unlockedPromotionRewardItemName
      );
    } else {
      promotionMessage = `${unlockedPromotion.promotion.name} unlocked! Apply at checkout.`;
    }
  } else if (closestPromotionToUnlock) {
    if (
      closestPromotionToUnlock.promotion.qualifying_item_details.length >= 1
    ) {
      promotionMessage = getQualifyingItemMessage(
        closestPromotionToUnlock,
        qualifyingItemName,
        rewardItemName
      );
    } else if (
      closestPromotionToUnlock.promotion.product_promotion_details.length >= 1
    ) {
      promotionMessage = getRewardItemMessage(
        closestPromotionToUnlock,
        rewardItemName
      );
    } else {
      promotionMessage = `$${closestPromotionToUnlock.amount_before_unlocked} more to unlock ${closestPromotionToUnlock.promotion.name}`;
    }
  }
  const formattedPromotionMessage = formatSentenceWithAVsAn(promotionMessage);
  return formattedPromotionMessage;
}

export function usePromotionProgressCartUpdateMesssage() {
  const unlockedPromotion = useUnlockedPromotionByLastAction();
  const closestPromotionToUnlock = useClosestPromotionToUnlock();
  const qualifyingItemName =
    closestPromotionToUnlock?.promotion?.qualifying_item_details.length === 1 &&
    closestPromotionToUnlock?.promotion?.qualifying_item_details[0].name;
  const rewardItemName =
    closestPromotionToUnlock?.promotion?.product_promotion_details.length ===
      1 &&
    closestPromotionToUnlock?.promotion?.product_promotion_details[0].name;
  const unlockedPromotionRewardItemName =
    unlockedPromotion?.promotion?.product_promotion_details.length === 1 &&
    unlockedPromotion?.promotion?.product_promotion_details[0].name;

  return handlePromotionProgressUpdateMessage(
    unlockedPromotion,
    closestPromotionToUnlock,
    qualifyingItemName,
    rewardItemName,
    unlockedPromotionRewardItemName
  );
}
